import axios from 'axios';
import { publicBaseUrl } from '@/core';

/**
 *
 * Changed from mutating original object by delete to an object assign on the original object assigning to a local copy for added safety.
 * NOTE: Not sure what intention was
 * Removed thrown promise error as e already is an error, removing error duplication
 *
 */

export default async function publicRequest(request) {
	let userAuth = require('./userAuth').default;

	let user = await userAuth.getCurrentUser();
	let token = user ? await user.getIdToken() : '';

	let reqObj= Object.assign(request, {
		baseURL: publicBaseUrl(),
		headers: { Authorization: `Bearer ${token}` }
	});

	try {
		let res = await axios(reqObj);
		return res.data;
	} catch (e) {
		throw e;
	}
}
